/**
 * <product-gallery> — thumbnail-rail switch + keyboard nav.
 * Listens for "media:select" events (dispatched by variant-picker) to switch on color change.
 */
class ProductGallery extends globalThis.ThemeElement {
  connectedCallback() {
    this.slides = this.$$('[data-gallery-slide]');
    this.thumbs = this.$$('[data-gallery-thumb]');
    this.thumbs.forEach((btn) => {
      this.on(btn, 'click', () => this.show(btn.dataset.mediaIndex));
    });
    const initial = this.slides.find((s) => !s.hidden);
    if (initial) this.thumbs.forEach((t) => t.setAttribute('aria-pressed', t.dataset.mediaIndex === initial.dataset.mediaIndex ? 'true' : 'false'));
    this.on(document, 'media:select', (e) => {
      const mediaId = e.detail.mediaId;
      const slide = this.slides.find((s) => s.dataset.mediaId == mediaId);
      if (slide) this.show(slide.dataset.mediaIndex);
    });
    this.on(this, 'keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const idx = this.slides.findIndex((s) => !s.hidden);
      const next = e.key === 'ArrowRight' ? Math.min(this.slides.length - 1, idx + 1) : Math.max(0, idx - 1);
      this.show(this.slides[next].dataset.mediaIndex);
    });
  }
  show(index) {
    const i = String(index);
    this.slides.forEach((s) => { s.hidden = s.dataset.mediaIndex !== i; });
    this.thumbs.forEach((t) => t.setAttribute('aria-pressed', t.dataset.mediaIndex === i ? 'true' : 'false'));
  }
}
if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
